import { STEPPER_GREEN, DODGER_BLUE } from 'constants/colors'

export const SLOT_LIST_LIMIT = 22

export const FILTER_SEARCH_PLACEHOLDER = {
  language: 'Provider languages',
  counseling_approach: 'Counseling approaches',
}

export const RETURN_FILTER_KEY_MAPPING = {
  availability_type: 'availabilityType',
  area_of_concern: 'areaOfConcern',
  language: 'language',
  counseling_approach: 'counselingApproach',
  client_age_group: 'clientAgeGroup',
  gender: 'gender',
  time_of_day: 'timeOfDay',
  insurance_id: 'insuranceId',
}

export const FILTER_KEY_MAPPING = {
  availabilityType: 'availability_type',
  areaOfConcern: 'area_of_concern',
  language: 'language',
  counselingApproach: 'counseling_approach',
  clientAgeGroup: 'client_age_group',
  gender: 'gender',
  counselingType: 'counseling_type',
  timeOfDay: 'time_of_day',
  insuranceId: 'insurance_id',
}

export const LabelAppointmentMapping = {
  'In Person': 'in_person',
  Online: 'online',
}

export const AvailabilityFilterValues = {
  online: 'Online',
  inPerson: 'In Person',
}

export const availabilityColorMapping = {
  online: DODGER_BLUE,
  in_person: STEPPER_GREEN,
}
export const availabilityIconMapping = {
  online: '/icons/icon-camera.svg',
  in_person: '/icons/icon-in-person.svg',
}

export enum SortFilterKeys {
  DISTANCE = 'distance',
  AVAILABILITY = 'most_available',
}

export enum ShowSearchCondition {
  NEVER,
  ALWAYS,
  ON_EXPANDED_LIST,
  ON_LARGE_LIST,
}

export const sortFilterOptions: SelectItem[] = [
  { label: 'Sort by Distance', value: SortFilterKeys.DISTANCE },
  { label: 'Sort by Most Available', value: SortFilterKeys.AVAILABILITY },
]

export const orderByFilters: ProviderFilter[] = [
  {
    description: null,
    id: 'distance',
    mappingValue: null,
    priority: 2,
    type: 'orderBy', // API also accepts this value.
    value: 'Sort by Distance',
  },
  {
    description: null,
    id: 'most_available',
    mappingValue: null,
    priority: 2,
    type: 'orderBy', // API also accepts this value.
    value: 'Sort by Most Available',
  },
]

export enum ProviderDetailsAPIErrors {
  PROVIDER_DELETED = 'Provider Deleted',
  INCORRECT_PRACTITIONER = 'Incorrect Practitioner Type',
}

export const SLOT_LOCATION_MAP = {
  direct_match: 'direct_search_match',
  indirect_match: 'indirect_search_match',
  providers_profile: 'providers_profile',
  availability_modal: 'all_availability_shown_modal',
}

export const PRIMARY_FILTERS = ['location', 'counselingType', 'clientAgeGroup']

// the filters are listed on increasing order of priority. So counselingApproach is lowest priority
// (meaning it's removed first while forming waterfall buckets.)
export const SECONDARY_FILTERS = [
  'counselingApproach',
  'language',
  'availabilityType',
  'gender',
  'timeOfDay',
  'areaOfConcern',
  'insuranceId',
]

// Defined the call center schedule in total minutes for each day
export const callCenterSchedule = [
  { open: 8 * 60, close: 18 * 60 }, // Sunday: 8 AM - 6 PM
  { open: 8 * 60, close: 21 * 60 + 30 }, // Monday: 8 AM - 9:30 PM
  { open: 8 * 60, close: 21 * 60 + 30 }, // Tuesday: 8 AM - 9:30 PM
  { open: 8 * 60, close: 21 * 60 + 30 }, // Wednesday: 8 AM - 9:30 PM
  { open: 8 * 60, close: 21 * 60 + 30 }, // Thursday: 8 AM - 9:30 PM
  { open: 8 * 60, close: 21 * 60 + 30 }, // Friday: 8 AM - 9:30 PM
  { open: 8 * 60, close: 18 * 60 }, // Saturday: 8 AM - 6 PM
]

export const selfPayCheckListItem = {
  id: 'self-pay',
  name: 'Self-Pay / Out-of-pocket',
}

export const outOfPocketCheckListItem = {
  id: 'self-pay',
  name: 'out-of-pocket',
}
